var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"600px","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }